import React from 'react';
import { createCustomMessage, createClientMessage } from 'react-chatbot-kit';
import moment from 'moment';
import ChatCustomLoader from '../components/chatbot/ChatCustomLoader';
import Card from '../components/chatbot/Card';
import { chatbotApi } from '../common/src';
import axios from 'axios';

const ActionProvider = ({ createChatBotMessage, setState, children }) => {
  //console.log(children);

  const setPrev = () => {
    alert(0);
  };
  const handlePrev = (msg) => {
    let messages;

    setState((prev) => {
      messages = [...prev.messages];
      const pos = messages.indexOf(msg);
      messages.splice(pos - 3, messages.length);
      return { ...prev, messages };
    });

    // setTimeout(() => {
    //   setState((prev) => ({
    //     ...prev,
    //     messages: [...prev.messages, userMessage],
    //   }));
    // }, 1000);

    const userMessage = createClientMessage(msg);

    setState((prev) => {
      messages = [...prev.messages, userMessage];
      return { ...prev, messages };
    });

    // setState((prev) => ({
    //   ...prev,
    //   messages: [...prev.messages, userMessage],
    // }));

    localStorage.setItem('chat_messages', JSON.stringify(messages));
  };
  const handleHome = (dept) => {
    // //console.log('home...');
    const box = document.querySelector('body');
    const hbox = box.offsetHeight;
    document.getElementsByClassName(
      'react-chatbot-kit-chat-input-container'
    )[0].style.display = 'none';
    if (hbox <= 667) {
      document.getElementsByClassName(
        'react-chatbot-kit-chat-message-container'
      )[0].style.height = hbox - 140 + 'px';
    } else {
      document.getElementsByClassName(
        'react-chatbot-kit-chat-message-container'
      )[0].style.height = '610px';
    }

    setState((prev) => {
      const messages = [];
      return { ...prev, messages, prevMessage: '' };
    });

    const introMessage = createCustomMessage('', 'customIntroTop');
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, introMessage],
      // isLoading: false,
    }));

    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));

    // const introMessage = createCustomMessage('', 'customIntro');
    const userMessage = createCustomMessage(
      '안녕하세요! 애니플러스입니다.\n도움이 필요한 내용을 선택해 주세요!',
      'customTextMessage',
      {
        widget: 'widget-category',
        payload: {
          message:
            '안녕하세요! 애니플러스입니다.\n도움이 필요한 내용을 선택해 주세요!',
          writetime: moment(new Date()).format('HH:mm'),
          widget: true,
        },
      }
    );
    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1] = userMessage; // 마지막 메시지를 실제 응답으로 교체
        // messages.push(userMessage);
        return { ...prev, messages };
      });
      localStorage.setItem('chat_messages', JSON.stringify(messages));
      localStorage.removeItem('chat_prev');
    }, 1000);
  };

  const handleCategorySubSelect = (msg) => {
    setState((prev) => {
      const messages = [...prev.messages];
      messages.pop();
      return { ...prev, messages };
    });

    let messages;
    const userMessage = createClientMessage(msg);

    setState((prev) => {
      messages = [...prev.messages, userMessage];
      return { ...prev, messages };
    });

    localStorage.setItem('chat_messages', JSON.stringify(messages));
    // localStorage.setItem('chat_prev', JSON.stringify(msg));
    // setState((prev) => ({
    //   ...prev,
    //   messages: [...prev.messages, userMessage],
    //   // prevMessage: msg,
    // }));
  };

  const handleCategorySelect = (categoryCode, msg) => {
    setState((prev) => {
      const messages = [...prev.messages];
      messages.pop();
      // messages[messages.length - 1] = ''; // 마지막 메시지를 실제 응답으로 교체
      return { ...prev, messages };
    });

    const userMessage = createClientMessage(msg);

    let messages;
    setState((prev) => {
      messages = [...prev.messages, userMessage];
      return { ...prev, messages, prevMessage: msg };
    });

    localStorage.setItem('chat_messages', JSON.stringify(messages));
    localStorage.setItem('chat_prev', JSON.stringify(msg));
    // setState((prev) => ({
    //   ...prev,
    //   messages: [...prev.messages, userMessage],
    //   prevMessage: msg,
    // }));
  };

  const handleClientMessage = (msg) => {
    // //console.log('sadfsdafasdfasdf');
    // //console.log(MessageParser);
    setState((prev) => {
      const messages = [...prev.messages];
      messages.pop();
      // messages[messages.length - 1] = ''; // 마지막 메시지를 실제 응답으로 교체
      return { ...prev, messages };
    });

    const userMessage = createClientMessage(msg);
    let messages;
    setState((prev) => {
      messages = [...prev.messages, userMessage];
      return { ...prev, messages };
    });

    localStorage.setItem('chat_messages', JSON.stringify(messages));

    // setState((prev) => ({
    //   ...prev,
    //   messages: [...prev.messages, userMessage],
    // }));

    // handleMessage('어절수 구리구리구리');
  };

  const handleMessage = (returnMessage) => {
    const botMessage = createChatBotMessage(returnMessage);
    //console.log(botMessage);

    let messages;
    setState((prev) => {
      messages = [...prev.messages, botMessage];
      return { ...prev, messages };
    });

    localStorage.setItem('chat_messages', JSON.stringify(messages));

    // setState((prev) => ({
    //   ...prev,
    //   messages: [...prev.messages, botMessage],
    // }));
  };

  const customMessageCard = (
    customName,
    message,
    widgetName,
    widget,
    list,
    icon
  ) => {
    const writetime = moment(new Date()).format('HH:mm');
    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));

    const botMessage = createCustomMessage('Test', customName, {
      widget: widgetName,
      payload: {
        message: list.title + ' 정보입니다.',
        writetime: moment(new Date()).format('HH:mm'),
        widget: widget,
        list: list,
        icon: icon,
      },
    });

    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });
      localStorage.setItem('chat_messages', JSON.stringify(messages));
    }, 1000);
  };

  const customMessageList = (
    customName,
    message,
    widgetName,
    widget,
    list,
    param,
    date
  ) => {
    // alert(widgetName, message);
    const writetime = moment(new Date()).format('HH:mm');

    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));

    const botMessage = createCustomMessage('Test', customName, {
      widget: widgetName,
      payload: {
        message: message,
        writetime: writetime,
        widget: widget,
        list: list,
        param: param,
        date: date,
      },
    });

    // //console.log(...prev.messages.length);
    // setState((prev) => ({
    //   ...prev,
    //   messages: [...prev.messages, botMessage],
    //   // isLoading: false,
    // }));
    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });
      localStorage.setItem('chat_messages', JSON.stringify(messages));
    }, 1000);
  };

  const customMessage = (
    customName,
    message,
    widgetName,
    widget,
    param,
    date,
    icon
  ) => {
    // alert(widgetName, message);
    const writetime = moment(new Date()).format('HH:mm');

    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));
    //console.log(customName, message, widgetName, widget, param);

    const botMessage = createCustomMessage('Test', customName, {
      widget: widgetName,
      payload: {
        message: message,
        writetime: writetime,
        widget: widget,
        param: param,
        date: date,
        icon: icon,
      },
    });

    // //console.log(...prev.messages.length);
    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });
      localStorage.setItem('chat_messages', JSON.stringify(messages));
    }, 1000);
  };
  const customMessageLate = (
    customName,
    message,
    widgetName,
    widget,
    param,
    date,
    list
  ) => {
    // alert(widgetName, message);
    const writetime = moment(new Date()).format('HH:mm');

    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));
    //console.log(customName, message, widgetName, widget, param);

    const botMessage = createCustomMessage('Test', customName, {
      // widget: widgetName,
      payload: {
        message: message,
        writetime: writetime,
        widget: widget,
        param: param,
        date: date,
        list: list,
      },
    });

    // //console.log(...prev.messages.length);
    setTimeout(() => {
      setState((prev) => {
        const messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });
    }, 1000);

    // 시간차를 두고 위젯을 표시함.
    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1].widget = widgetName; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });

      localStorage.setItem('chat_messages', JSON.stringify(messages));
    }, 2000);

    // setState((prev) => {({
    //   ...prev,
    //   messages: [...prev.messages, botMessage],
    //   messages: [...prev.messages[...prev.messages.length - 1]]
    //   // isLoading: false,
    // }));
  };

  const handleYesno = (msg) => {
    const userMessage = createClientMessage(msg);
    let messages;
    setState((prev) => {
      messages = [...prev.messages];
      messages[messages.length - 1] = userMessage; // 마지막 메시지를 실제 응답으로 교체
      return { ...prev, messages };
    });

    localStorage.setItem('chat_messages', JSON.stringify(messages));
  };

  const handleLogin = (msg) => {
    // const userMessage = createClientMessage(msg);
    const writetime = moment(new Date()).format('HH:mm');

    const botMessage = createCustomMessage('Test', 'customTextMessage', {
      widget: 'widget-login',
      payload: {
        message: '로그인후 이용해 주세요',
        writetime: writetime,
        widget: true,
      },
    });

    let messages;
    setState((prev) => {
      messages = [...prev.messages, botMessage];
      return { ...prev, messages };
    });

    localStorage.setItem('chat_messages', JSON.stringify(messages));

    // setState((prev) => ({
    //   ...prev,
    //   messages: [...prev.messages, botMessage],
    //   // prevMessage: msg,
    // }));
  };

  const handleEtc = (msg) => {
    setState((prev) => {
      const messages = [...prev.messages];
      messages.pop();
      // messages[messages.length - 1] = ''; // 마지막 메시지를 실제 응답으로 교체
      return { ...prev, messages };
    });

    // custom hook으로 빼낼것.
    const userMessage = createClientMessage(msg);
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, userMessage],
      //prevMessage: msg,
    }));

    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));

    const botMessage = createCustomMessage('msg1', 'customSelectMessage', {
      widget: 'widget-etc',
      payload: {
        message: 'msg1',
        writetime: moment(new Date()).format('HH:mm'),
        widget: true,
      },
    });
    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });

      localStorage.setItem('chat_messages', JSON.stringify(messages));
    }, 1000);
  };

  const handleQna = (msg) => {
    setState((prev) => {
      const messages = [...prev.messages];
      messages.pop();
      // messages[messages.length - 1] = ''; // 마지막 메시지를 실제 응답으로 교체
      return { ...prev, messages };
    });

    const userMessage = createClientMessage(msg);

    let messages;
    setState((prev) => {
      messages = [...prev.messages, userMessage];
      return { ...prev, messages };
    });

    localStorage.setItem('chat_messages', JSON.stringify(messages));

    // setState((prev) => ({
    //   ...prev,
    //   messages: [...prev.messages, userMessage],
    // }));
  };

  const handleQnaSuccess = (msg) => {
    const writetime = moment(new Date()).format('HH:mm');
    setState((prev) => {
      const messages = [...prev.messages];
      messages.pop();
      // messages[messages.length - 1] = ''; // 마지막 메시지를 실제 응답으로 교체
      return { ...prev, messages };
    });

    const userMessage = createClientMessage(msg);
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, userMessage],
    }));

    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));

    const botMessage = createCustomMessage('Test', 'customTextMessage', {
      widget: 'widget-prev',
      payload: {
        message:
          '입력하신 내용이 정상적으로 1:1문의에 등록되었습니다. \n담당자가 확인후 답변드리겠습니다. 답변글은 1:1 문의 게시판을 이용해주세요.',
        writetime: writetime,
        widget: false,
      },
    });

    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });
      localStorage.setItem('chat_messages', JSON.stringify(messages));
    }, 1000);
  };

  const handleChat = (msg) => {
    const writetime = moment(new Date()).format('HH:mm');
    setState((prev) => {
      const messages = [...prev.messages];
      messages.pop();
      // messages[messages.length - 1] = ''; // 마지막 메시지를 실제 응답으로 교체
      return { ...prev, messages };
    });

    const userMessage = createClientMessage(msg);
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, userMessage],
      // prevMessage: msg,
    }));

    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));

    const botMessage = createCustomMessage('Test', 'customTextMessage', {
      widget: 'widget-chat',
      payload: {
        message: '채팅으로 문의하기',
        writetime: writetime,
        widget: false,
      },
    });

    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages, prevMessage: msg };
      });

      localStorage.setItem('chat_messages', JSON.stringify(messages));
      localStorage.setItem('chat_prev', JSON.stringify(msg));
    }, 1000);
  };
  const handleSameCodeSelect = (msg) => {
    setState((prev) => {
      const messages = [...prev.messages];
      messages.pop();
      // messages[messages.length - 1] = ''; // 마지막 메시지를 실제 응답으로 교체
      return { ...prev, messages };
    });

    // custom hook으로 빼낼것.
    const userMessage = createClientMessage(msg);
    let messages;
    setState((prev) => {
      messages = [...prev.messages, userMessage];
      return { ...prev, messages };
    });

    localStorage.setItem('chat_messages', JSON.stringify(messages));
    // setState((prev) => ({
    //   ...prev,
    //   messages: [...prev.messages, userMessage],
    //   //prevMessage: msg,
    // }));

    // const loadingMessage = createChatBotMessage(<ChatCustomLoader />);
    // setState((prev) => ({
    //   ...prev,
    //   messages: [...prev.messages, loadingMessage],
    //   // isLoading: false,
    // }));
  };
  const handleTimeline = async (msg, contentSerial) => {
    //console.log(contentSerial);
    const writetime = moment(new Date()).format('HH:mm');
    setState((prev) => {
      const messages = [...prev.messages];
      messages.pop();
      // messages[messages.length - 1] = ''; // 마지막 메시지를 실제 응답으로 교체
      return { ...prev, messages };
    });

    const userMessage = createClientMessage(msg);
    let messages;
    setState((prev) => {
      messages = [...prev.messages, userMessage];
      return { ...prev, messages };
    });

    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));

    const result = await axios(
      chatbotApi + '/api/getContentTimeline?contentSerial=' + contentSerial
    );
    const intReturn = result.data.intReturn;
    const comment = result.data.comment;
    //console.log(intReturn);
    let botMessage;
    if (intReturn === 0) {
      const list = result.data.listData;
      botMessage = createCustomMessage('Test', 'customTextMessage', {
        widget: 'widget-content-timeline',
        payload: {
          message: list[0].title + ' 편성 정보입니다.',
          writetime: writetime,
          widget: true,
          list: list,
          param: comment,
        },
      });
    } else {
      botMessage = createCustomMessage('Test', 'customTextMessage', {
        widget: 'widget-prev',
        payload: {
          message:
            '현재 방송사 사정으로 인해\n해당 프로그램은 편성되지 않았습니다.',
          writetime: writetime,
          widget: false,
        },
      });
    }
    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });
      localStorage.setItem('chat_messages', JSON.stringify(messages));
    }, 1000);
  };
  const handleIntroStart = () => {
    const writetime = moment(new Date()).format('HH:mm');
    setState((prev) => {
      const messages = [...prev.messages];
      messages.pop();
      // messages[messages.length - 1] = ''; // 마지막 메시지를 실제 응답으로 교체
      return { ...prev, messages };
    });
    // createCustomMessage('', 'customIntro'),
    const introMessage = createCustomMessage('', 'customIntroTop');
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, introMessage],
      // isLoading: false,
    }));

    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));

    const botMessage = createCustomMessage('Test', 'customTextMessage', {
      widget: '',
      payload: {
        message:
          '안녕하세요! 애니플러스입니다.\n도움이 필요한 내용을 선택해 주세요!',
        writetime: writetime,
        widget: false,
      },
    });
    setTimeout(() => {
      setState((prev) => {
        const messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });
    }, 1000);

    const botMessage1 = createCustomMessage('Test', 'customSelectMessage', {
      widget: 'widget-category',
      payload: {
        message: 'msg1',
        writetime: writetime,
        widget: true,
      },
    });

    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length] = botMessage1; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });
      localStorage.setItem('chat_messages', JSON.stringify(messages));
    }, 2000);
  };
  const handleSimpleMsg = (msg) => {
    const writetime = moment(new Date()).format('HH:mm');
    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));

    const botMessage = createCustomMessage('Test', 'customTextMessage', {
      widget: 'widget-cart',
      payload: {
        message: msg,
        writetime: writetime,
        widget: false,
      },
    });

    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });
      localStorage.setItem('chat_messages', JSON.stringify(messages));
    }, 1000);
  };
  const handleEnd = () => {
    const box = document.querySelector('body');
    const hbox = box.offsetHeight;

    document.getElementsByClassName(
      'react-chatbot-kit-chat-input-container'
    )[0].style.display = 'none';

    if (hbox <= 667) {
      document.getElementsByClassName(
        'react-chatbot-kit-chat-message-container'
      )[0].style.height = hbox - 140 + 'px';
    } else {
      document.getElementsByClassName(
        'react-chatbot-kit-chat-message-container'
      )[0].style.height = '610px';
    }

    setState((prev) => {
      const messages = [];
      return { ...prev, messages, prevMessage: '' };
    });

    const botMessage = createCustomMessage('', 'customIntro');

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
      //prevMessage: msg,
    }));

    localStorage.removeItem('chat_messages');
    localStorage.removeItem('chat_prev');
  };

  const handleDeliveryInfo = async (
    orderCode,
    SaleType,
    goodSerial,
    deliverySate
  ) => {
    const writetime = moment(new Date()).format('HH:mm');
    let msg;
    if (deliverySate === '배송완료') {
      msg = '해당 상품은 배송이 완료되었습니다.';
    } else if (deliverySate === '배송중') {
      const result = await axios(
        chatbotApi +
          '/api/getDeliveryNumber?orderCode=' +
          orderCode +
          '&goodSerial=' +
          goodSerial
      );
      const intReturn = result.data.intReturn;
      if (intReturn === 0) {
        msg =
          '고객님께서 주문하신 상품이 cj대한통운 운송장번호 ' +
          result.data.listData[0].deliveryCode +
          ' 를 통해 배송 중에 있습니다.\n\n배송 중에는 배송지 변경이 불가한 점 참고 부탁드립니다.';
      } else {
        msg = '해당 상품의 배송 정보가 존재하지 않습니다.';
      }
    } else {
      if (SaleType === 'A') {
        const result = await axios(
          chatbotApi + '/api/getDeliveryDate?goodSerial=' + goodSerial
        );
        const intReturn = result.data.intReturn;
        if (intReturn === 0) {
          msg =
            '해당 상품의 예상 발매일은\n' +
            result.data.listData[0].openday +
            ' 입니다.\n\n일본 수입 상품의 경우 배송 기간은 “일본 발매일”로부터 1개월 ~ 최대 3개월 정도 소요될 수 있습니다.\n콜라보 굿즈, 오리지널 굿즈는 일본 기준이 아닌 국내 기준 발매일로, 발매일이 배송 시작일입니다.\n제작사 사정에 따라 배송 일자가 변경될 수 있습니다.';
        } else {
          msg = '해당 상품의 정보가 존재하지 않습니다.';
        }
      } else {
        msg =
          '바로 배송 상품의 배송 기간은 주문 완료 후 2~7일이 소요될 수 있습니다.';
      }
    }

    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));

    const botMessage = createCustomMessage('Test', 'customTextMessage', {
      widget: 'widget-customer',
      payload: {
        message: msg,
        writetime: writetime,
        widget: false,
      },
    });

    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });
      localStorage.setItem('chat_messages', JSON.stringify(messages));
    }, 1000);
  };

  const handleCancelInfo = (
    orderCode,
    SaleType,
    goodSerial,
    deliverySate,
    saleEnd,
    goodTotalPrice
  ) => {
    const writetime = moment(new Date()).format('HH:mm');
    let msg;

    if (SaleType === 'A') {
      if (
        moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
        moment(saleEnd).format('YYYY-MM-DD HH:mm:ss')
      ) {
        msg =
          '해당 상품은 예약배송 상품입니다.\n\n해당 상품의 예약 마감일은 ' +
          moment(saleEnd).format('YYYY년 MM월 DD일') +
          '입니다.\n ' +
          moment(saleEnd).format('YYYY년 MM월 DD일') +
          '이후에는 상품 취소 시 20%의 위약금이 부과됩니다.\n상품가의 ' +
          goodTotalPrice +
          '원에서 20% 수수료를 제외한 값 ' +
          goodTotalPrice * 0.8 +
          '원이 환불됩니다.\n\n상품 취소를 희망하시는 경우\n“애니플러스 온라인샵 접속 > 로그인 > 마이 쇼핑 > 주문 취소”\n의 절차를 통해 상품의 주문을 취소하실 수 있습니다.\n환불의 경우 카드사 및 결제 수단에 따라 환불 시간 소요일이 상이합니다.\n애니플러스샵 내에서 주문 취소가 완료된 건의 자세한 환불 일자는\n결제를 진행하신 카드사 혹은 은행의 고객센터로 문의해주시길 바랍니다.\n포인트 부족, 결제 수단 등의 사유로 취소가 불가하신 경우 온라인샵 1:1문의를 통해 문의해주시길 바랍니다.';
      } else {
        msg =
          '해당 상품은 예약배송 상품입니다.\n\n해당 상품의 예약 마감일은 ' +
          moment(saleEnd).format('YYYY년 MM월 DD일') +
          '입니다.\n' +
          moment(saleEnd).format('YYYY년 MM월 DD일') +
          '이후에는 상품 취소 시 20%의 위약금이 부과됩니다.\n상품 취소를 희망하시는 경우\n“애니플러스 온라인샵 접속 > 로그인 > 마이 쇼핑 > 주문 취소”\n의 절차를 통해 상품의 주문을 취소하실 수 있습니다.\n환불의 경우 카드사 및 결제 수단에 따라 환불 시간 소요일이 상이합니다.\n애니플러스샵 내에서 주문 취소가 완료된 건의 자세한 환불 일자는\n결제를 진행하신 카드사 혹은 은행의 고객센터로 문의해주시길 바랍니다.\n포인트 부족, 결제 수단 등의 사유로 취소가 불가하신 경우 온라인샵 1:1문의를 통해 문의해주시길 바랍니다.';
      }
    } else {
      if (deliverySate === '배송중' || deliverySate === '배송완료') {
        msg =
          '해당 상품은 바로배송 상품입니다.\n\n배송이 시작된 후의 주문 취소는 불가능하며 반품을 통하여 주문의 취소가 가능합니다.';
      } else {
        msg =
          '해당 상품은 바로배송 상품입니다.\n\n“애니플러스 온라인샵 접속 > 로그인 > 마이 쇼핑 > 주문 취소”의 절차를 통해 상품의 주문을 취소하실 수 있습니다.\n\n환불의 경우 카드사 및 결제 수단에 따라 환불 시간 소요일이 상이합니다.\n애니플러스샵 내에서 주문 취소가 완료된 건의 자세한 환불 일자는 결제를 진행하신 카드사 혹은 은행의 고객센터로 문의해주시길 바랍니다.\n\n포인트 부족, 결제 수단 등의 사유로 취소가 불가하신 경우 온라인샵 1:1문의를 통해 문의해주시길 바랍니다.';
      }
    }

    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));

    const botMessage = createCustomMessage('Test', 'customTextMessage', {
      widget: 'widget-customer',
      payload: {
        message: msg,
        writetime: writetime,
        widget: false,
      },
    });

    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });
      localStorage.setItem('chat_messages', JSON.stringify(messages));
    }, 1000);
  };

  const handleReturnInfo = (
    orderCode,
    SaleType,
    goodSerial,
    deliverySate,
    saleEnd,
    goodTotalPrice
  ) => {
    const writetime = moment(new Date()).format('HH:mm');
    let msg;

    if (SaleType === 'A') {
      if (
        moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
        moment(saleEnd).format('YYYY-MM-DD HH:mm:ss')
      ) {
        msg =
          '해당 상품은 예약배송 상품입니다.\n\n해당 상품의 예약 마감일은 ' +
          moment(saleEnd).format('YYYY년 MM월 DD일') +
          '입니다.\n ' +
          moment(saleEnd).format('YYYY년 MM월 DD일') +
          '이후에는 상품 취소 시 20%의 위약금이 부과됩니다.\n상품가의 ' +
          goodTotalPrice +
          '원에서 20% 수수료를 제외한 값 ' +
          goodTotalPrice * 0.8 +
          '원이 환불됩니다.\n\n상품 취소를 희망하시는 경우\n“애니플러스 온라인샵 접속 > 로그인 > 마이 쇼핑 > 주문 취소”\n의 절차를 통해 상품의 주문을 취소하실 수 있습니다.\n환불의 경우 카드사 및 결제 수단에 따라 환불 시간 소요일이 상이합니다.\n애니플러스샵 내에서 주문 취소가 완료된 건의 자세한 환불 일자는\n결제를 진행하신 카드사 혹은 은행의 고객센터로 문의해주시길 바랍니다.\n포인트 부족, 결제 수단 등의 사유로 취소가 불가하신 경우 온라인샵 1:1문의를 통해 문의해주시길 바랍니다.';
      } else {
        msg =
          '해당 상품은 예약배송 상품입니다.\n\n해당 상품의 예약 마감일은 ' +
          moment(saleEnd).format('YYYY년 MM월 DD일') +
          '입니다.\n' +
          moment(saleEnd).format('YYYY년 MM월 DD일') +
          '이후에는 상품 취소 시 20%의 위약금이 부과됩니다.\n상품 취소를 희망하시는 경우\n“애니플러스 온라인샵 접속 > 로그인 > 마이 쇼핑 > 주문 취소”\n의 절차를 통해 상품의 주문을 취소하실 수 있습니다.\n환불의 경우 카드사 및 결제 수단에 따라 환불 시간 소요일이 상이합니다.\n애니플러스샵 내에서 주문 취소가 완료된 건의 자세한 환불 일자는\n결제를 진행하신 카드사 혹은 은행의 고객센터로 문의해주시길 바랍니다.\n포인트 부족, 결제 수단 등의 사유로 취소가 불가하신 경우 온라인샵 1:1문의를 통해 문의해주시길 바랍니다.';
      }
    } else {
      if (deliverySate === '배송중' || deliverySate === '배송완료') {
        msg =
          '해당 상품은 바로배송 상품입니다.\n\n배송이 시작된 후의 주문 취소는 불가능하며 반품을 통하여 주문의 취소가 가능합니다.';
      } else {
        msg =
          '해당 상품은 바로배송 상품입니다.\n\n“애니플러스 온라인샵 접속 > 로그인 > 마이 쇼핑 > 주문 취소”의 절차를 통해 상품의 주문을 취소하실 수 있습니다.\n\n환불의 경우 카드사 및 결제 수단에 따라 환불 시간 소요일이 상이합니다.\n애니플러스샵 내에서 주문 취소가 완료된 건의 자세한 환불 일자는 결제를 진행하신 카드사 혹은 은행의 고객센터로 문의해주시길 바랍니다.\n\n포인트 부족, 결제 수단 등의 사유로 취소가 불가하신 경우 온라인샵 1:1문의를 통해 문의해주시길 바랍니다.';
      }
    }

    const loadingMessage = createChatBotMessage(<ChatCustomLoader />);
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, loadingMessage],
      // isLoading: false,
    }));

    const botMessage = createCustomMessage('Test', 'customTextMessage', {
      widget: 'widget-customer',
      payload: {
        message: msg,
        writetime: writetime,
        widget: false,
      },
    });

    setTimeout(() => {
      let messages;
      setState((prev) => {
        messages = [...prev.messages];
        messages[messages.length - 1] = botMessage; // 마지막 메시지를 실제 응답으로 교체
        return { ...prev, messages };
      });
      localStorage.setItem('chat_messages', JSON.stringify(messages));
    }, 1000);
  };

  const showLoader = () => {
    setState((prev) => ({
      ...prev,
      isLoading: true,
    }));
  };
  const setSession = (sessionKey) => {
    //console.log(sessionKey);
    setState((prev) => ({
      ...prev,
      sessionKey,
    }));
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        // //console.log(child);
        return React.cloneElement(child, {
          actions: {
            handleMessage,
            handleClientMessage,
            customMessage,
            customMessageList,
            customMessageCard,
            customMessageLate,
            showLoader,
            handleCategorySelect,
            handleHome,
            handleCategorySubSelect,
            handlePrev,
            handleYesno,
            handleLogin,
            handleEtc,
            handleQna,
            handleQnaSuccess,
            handleChat,
            handleSameCodeSelect,
            handleIntroStart,
            handleEnd,
            setSession,
            handleSimpleMsg,
            setPrev,
            handleTimeline,
            handleDeliveryInfo,
            handleCancelInfo,
            handleReturnInfo,
          },
        });
      })}
    </div>
  );
};

// export default shopContext(withRouter(ActionProvider));

export default ActionProvider;
